import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { SmartAudioProvider } from '../../providers/smart-audio/smart-audio';

import { LivePage } from '../live/live';
import { UpcomingPage } from '../upcoming/upcoming';
import { HomePage } from '../home/home';

@Component({
  templateUrl: 'public-tabs.html'
})
export class PublicTabsPage {

  tab1Root: any = LivePage;
  tab2Root: any = HomePage;
  tab3Root: any = UpcomingPage;
  //tab4Root: any = Tab4Root;
  //tab5Root: any = Tab5Root;

  tab1Title = "tab 1";
  tab2Title = "tab 2";
  tab3Title = "tab 3";
  tab4Title = " ";
  tab5Title = " ";
  pageHeader: any = " ";

  constructor(public navCtrl: NavController,
              public translateService: TranslateService,
              public smartAudio: SmartAudioProvider) {
    /*translateService.get(['TAB1_TITLE', 'TAB2_TITLE', 'TAB3_TITLE', 'TAB4_TITLE', 'TAB5_TITLE']).subscribe(values => {
      this.tab1Title = values['TAB1_TITLE'];
      this.tab2Title = values['TAB2_TITLE'];
      this.tab3Title = values['TAB3_TITLE'];
      this.tab4Title = values['TAB4_TITLE'];
      this.tab5Title = values['TAB5_TITLE'];
    });*/
  }

  changeTab() {
    this.smartAudio.play('click');
    this.navCtrl.popToRoot();
    if(this.navCtrl.parent){
      this.navCtrl.parent.popToRoot();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/public-tabs/public-tabs.ts